import { useEffect, useState } from "react";
import { isOneOf, isString } from "typescript_helpers";
import { RowGrid } from "../divider and frames/layouts";
import { Modal } from "../modals/modal";
import { HeaderSmall, HeaderTiny, Indent } from "../text_display/main_content_text_styling";
import { CircleLoader } from "../widgets/loader";
import styled from "styled-components";
import { useAuth } from "../../authentication/auth_provider";
import { ErrorMessage } from "../themes and styles/error";
import { DownloadProposalButton as DownloadIntentionButton } from "../buttons/menu_area_buttons";
import { useProposalSelectionMapping } from "../contexts/proposalsSelectionMapping/provider";

function Error({message}){
  if (isString(message) && message !== ""){

    return (
      <>
        <p>
          Available error message:
        </p>
        <Indent margin_left={"24px"}>
          <ErrorMessage>
            {message}
          </ErrorMessage>
        </Indent>
    </>
    )
  }
}

export function NoteIntentionSubmitModal({closeModalCallback, intention, mode}){
  const [status, setStatus] = useState('loading');
  const [message, setMessage] = useState('');
  const {mail, token, role} = useAuth();
  const [request_sent, set_request_send] = useState(false);
  const {selectionManager} = useProposalSelectionMapping();

  useEffect(()=>{

    !request_sent && processIntention(processingCallback) && set_request_send(true);
  },[])

  const processingCallback = (intention) => {
    if (intention.db_response === undefined || intention.db_response === null) {
      setStatus('error');
      setMessage('No response from database server. Please try again later.');
      return;
    }
    if (intention.db_response.status === 'request_success') {
      processVariables(intention);
      return;
    }
    setStatus('error');
    setMessage(intention.db_response.message);
  }

  async function processVariables(intention){
    const requestor_mail = (((mode === 'nachtragen') && mail)||intention.getIntentionAttribute('USER'));
    try{
      await selectionManager.db_set_variables_for_proposal(requestor_mail, token, intention.getIntentionAttribute('id'), null);
      setStatus('success');
    }
    catch (error){
      setStatus('error');
      setMessage(error.message);
    }
  }

  async function processIntention(callback){
    
    try{
      if (mode !== 'nachtragen' && isOneOf(intention.getIntentionAttribute('USER'), [null, undefined, "", false]))
      {
        intention.setIntentionAttribute('USER', mail);
      }
      let response_intention = null;
      if(mode === 'nachtragen'){
        response_intention = await intention.db_intention_nachtragen(mail, token);
      }
      else {
        response_intention = await intention.db_create_intention(mail, token);
      }
      callback(response_intention);
    }
    catch (error){
      setStatus('error');
      setMessage(error.message);
    }
  }

  return (
    <Modal closeModalCallback={closeModalCallback}>
      <RowGrid>
        {
          ((status === 'loading') && 
            <>
              <HeaderTiny text={"Processing Intention"} />
              <CircleLoader/>
            </>) ||
          ((status === 'error') &&
            <>
              <HeaderTiny text={"Processing Intention"} />
              <Indent margin_left={"24px"}>
                Something went wrong and processing of intention failed.
                <Error message={message}/>
              </Indent>
            </>
          ) ||
          ((status === 'success') && 
            <>
              <HeaderTiny text={"Processing Intention"} />
              <Indent margin_left={"24px"}>
                Intention has been uploaded and selected Variables got associated with intention
                  <DownloadIntentionButton intention={intention}/>
              </Indent>
            </>)
          
        }
      </RowGrid>
    </Modal>
  )
}
